import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PiecePopUpNewsletterRenderComponent } from 'extensions/st/piece-pop-up-newsletter/front/piece-pop-up-newsletter-render.component';


export const piecePopUpNewsletterRenderModuleEntryComponents = [
  PiecePopUpNewsletterRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: piecePopUpNewsletterRenderModuleEntryComponents
})
export class PiecePopUpNewsletterRenderModule {}

export default piecePopUpNewsletterRenderModuleEntryComponents;
